'use strict';

var jsxRuntime = require('react/jsx-runtime');
var react = require('react');
require('../../_chunks/fonts-CZ0t0x6L.js');
var utilities_combineClasses = require('../../_chunks/combineClasses-5P8GTQkg.js');
var theme_index = require('../../_chunks/index-CIVOGJRG.js');
require('../../_chunks/designTokens-CKP-YoT2.js');

require("../../_assets/Text-Ccf3K4dk.css");var styles = {"ellipsis":"Text__qp-rZ4QDiL__ellipsis","text":"Text__qp-rZ4QDiL__text"};

const Text = react.forwardRef(({ as, styleAs, className, style, size: _size, color: _color, bold: _bold, ellipsis, testId, ...props }, ref) => {
    const As = as ?? 'span';
    const variant = styleAs ?? As;
    const textStyle = tagToStyleMap[variant];
    const size = _size ?? textStyle.size;
    const color = _color ?? textStyle.color;
    const bold = _bold ?? textStyle.bold;
    return (jsxRuntime.jsx(As, { ref: ref, className: utilities_combineClasses.combineClasses(className, styles.text, ellipsis && styles.ellipsis), style: {
            '--text--color': theme_index.theme.color[color] ?? color,
            '--text--font-size': theme_index.theme.fontSize[size] ?? size,
            '--text--line-height': theme_index.theme.lineHeight[size] ?? size,
            '--text--font-weight': typeof bold === 'boolean'
                ? theme_index.theme.fontWeight[bold ? 'bold' : 'regular']
                : bold,
            ...style,
        }, "data-testid": testId, ...props }));
});
Text.displayName = 'Text';
const tagToStyleMap = {
    span: {
        size: '200',
        bold: false,
        color: 'gray-800',
    },
    get p() {
        return this.span;
    },
    get div() {
        return this.span;
    },
    h1: {
        size: '700',
        bold: true,
        color: 'gray-900',
    },
    h2: {
        size: '600',
        bold: true,
        color: 'gray-900',
    },
    h3: {
        size: '500',
        bold: true,
        color: 'gray-900',
    },
    h4: {
        size: '400',
        bold: true,
        color: 'gray-900',
    },
    h5: {
        size: '300',
        bold: true,
        color: 'gray-900',
    },
    h6: {
        size: '200',
        bold: true,
        color: 'gray-900',
    },
};

exports.Text = Text;
//# sourceMappingURL=Text.js.map
